import { Amplify } from "aws-amplify";

Amplify.configure({
  // aws-exports.js equivalent
  aws_project_region: "eu-west-1",
  aws_cognito_region: "eu-west-1",
  aws_user_pools_id: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
  aws_user_pools_web_client_id: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: [],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS",
    ],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_appsync_graphqlEndpoint: process.env.NEXT_PUBLIC_AUDIT_API_URL,
  aws_appsync_region: "eu-west-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",


  //
  ssr: false,
  oauth: {
    domain: `${process.env.NEXT_PUBLIC_COGNITO_USER_POOL_DOMAIN}.auth.eu-west-1.amazoncognito.com`,
    clientId: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
    scope: [
      "openid",
      "email",
      "profile",
      "phone",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: process.env.NEXT_PUBLIC_REDIRECT_SIGN_IN,
    redirectSignOut: process.env.NEXT_PUBLIC_REDIRECT_SIGN_OUT,
    responseType: "code",
    ...() => {
      if (
        !JSON.parse(process.env.NEXT_PUBLIC_AMPLIFY_COOKIE_STORAGE) as boolean
      ) {
        return {};
      }

      return {
        cookieStorage: {
          domain: process.env.NEXT_PUBLIC_AMPLIFY_COOKIE_STORAGE_DOMAIN,
          path: process.env.NEXT_PUBLIC_AMPLIFY_COOKIE_STORAGE_PATH,
          expires: process.env.NEXT_PUBLIC_AMPLIFY_COOKIE_STORAGE_EXPIRES,
          sameSite: process.env.NEXT_PUBLIC_AMPLIFY_COOKIE_STORAGE_SAME_SITE,
          secure: JSON.parse(
            process.env.NEXT_PUBLIC_AMPLIFY_COOKIE_STORAGE_SECURE
          ) as boolean,
        },
      };
    },
  },
});
